import React from 'react';

import MainTemplate from 'pages/templates/MainTemplate';

const CustomizedBanner = () => {
  return (
    <MainTemplate>
      <h2>맞춤형 배너</h2>
    </MainTemplate>
  );
};

export default CustomizedBanner;
